module.exports = __webpack_public_path__ + "img/stproduct.0d894fd1.png";